import React, { useState, useEffect } from "react";
import { Menu, X, Terminal } from "lucide-react";
import { personalInfo } from "../data/mock";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        height: "80px",
        background: isScrolled ? "rgba(0, 0, 0, 0.95)" : "var(--bg-primary)",
        borderBottom: `1px solid ${isScrolled ? "var(--border-medium)" : "var(--border-subtle)"}`,
        padding: "16px 7.6923%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        zIndex: 1000,
        backdropFilter: isScrolled ? "blur(10px)" : "none",
        transition: "all 0.3s ease",
      }}
    >
      {/* Logo */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          cursor: "pointer",
        }}
        onClick={() => scrollToSection("hero")}
      >
        <Terminal size={28} color="var(--brand-primary)" />
        <span
          style={{
            fontSize: "20px",
            fontWeight: 600,
            color: "var(--text-primary)",
          }}
        >
          {personalInfo.name.split(" ")[0]}
        </span>
      </div>

      {/* Desktop Navigation */}
      <nav
        style={{
          display: "flex",
          alignItems: "center",
          gap: "32px",
        }}
        className="desktop-nav"
      >
        {["About", "Skills", "Experience", "Projects", "Contact"].map((item) => (
          <button
            key={item}
            onClick={() => scrollToSection(item.toLowerCase())}
            style={{
              background: "none",
              border: "none",
              color: "var(--text-muted)",
              fontSize: "18px",
              fontWeight: 400,
              cursor: "pointer",
              transition: "color 0.3s ease",
            }}
            onMouseEnter={(e) => (e.target.style.color = "var(--text-primary)")}
            onMouseLeave={(e) => (e.target.style.color = "var(--text-muted)")}
          >
            {item}
          </button>
        ))}
      </nav>

      {/* Mobile Menu Toggle */}
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        style={{
          display: "none",
          background: "none",
          border: "none",
          cursor: "pointer",
          color: "var(--brand-primary)",
        }}
        className="mobile-menu-toggle"
      >
        {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: "80px",
            left: 0,
            right: 0,
            background: "rgba(0, 0, 0, 0.98)",
            backdropFilter: "blur(10px)",
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
            borderBottom: "1px solid var(--border-subtle)",
          }}
          className="mobile-nav"
        >
          {["About", "Skills", "Experience", "Projects", "Contact"].map((item) => (
            <button
              key={item}
              onClick={() => scrollToSection(item.toLowerCase())}
              style={{
                background: "none",
                border: "none",
                color: "var(--text-secondary)",
                fontSize: "18px",
                fontWeight: 400,
                cursor: "pointer",
                textAlign: "left",
                padding: "10px",
              }}
            >
              {item}
            </button>
          ))}
        </div>
      )}

      <style>
        {`
          @media (max-width: 768px) {
            .desktop-nav {
              display: none !important;
            }
            .mobile-menu-toggle {
              display: block !important;
            }
          }
        `}
      </style>
    </header>
  );
};

export default Header;
